module.exports = __webpack_public_path__ + "img/html.4c20507a.png";